import NotFound from '@/views/General/NotFound.vue';
import DashboardLayout from '@/views/Layout/Layout.vue';
import Profile from '@/views/Dashboard/Profile.vue';
import Offers from '@/views/Dashboard/OffersNew.vue';
import Contacts from '@/views/Dashboard/Contacts.vue';
import Postbacks from '@/views/Dashboard/TrafficSources/Postbacks.vue';
import TagManager from '@/views/Dashboard/TrafficSources/TagManager.vue';
import RequestLog from '@/views/Dashboard/TrafficSources/RequestLog.vue';
import SubAffiliates from '@/views/Dashboard/SubAffiliates.vue';
import PromoMaterials from '@/views/Dashboard/PromoMaterials.vue';
import AdvertisingCampaigns from '@/views/Dashboard/MediaBuying/AdvertisingCampaign.vue';
import DetailAdCampaign from '@/views/Dashboard/MediaBuying/DetailAdCampaign.vue';
import DetailAdCampaignSub from '@/views/Dashboard/MediaBuying/DetailAdCampaignSub.vue';
import PaymentsView from '@/views/Dashboard/MediaBuying/PaymentsView/PaymentsView.vue';
import PostsView from '@/views/Dashboard/MediaBuying/PostsView/PostsView.vue';
import PaymentHistory from '@/views/Dashboard/Wallet.vue';
import PromoCodes from '@/views/Dashboard/PromoCodes.vue';
import AndroidApps from '@/views/Dashboard/AndroidApps.vue';
import LinksChecker from '@/views/Dashboard/MediaBuying/LinksChecker.vue';
import Notifications from '@/views/Dashboard/Notifications.vue';
import Domains from 'src/views/Dashboard/Domains.vue';
import TrafficSource from '@/views/Dashboard/TrafficSource.vue';
import Summary from '@/views/Dashboard/Summary.vue';
import Daily from '@/views/Dashboard/DailyReports.vue';
import Players from '@/views/Dashboard/PlayerReports.vue';
import Custom from '@/views/Dashboard/CustomReports.vue';
import SubAffiliatesReports from '@/views/Dashboard/SubAffiliatesReports.vue';
import Index from '@/views/Dashboard/Index.vue';
import withLoader from '@/components/withLoader';
import IndexLoader from '@/views/Loaders/Index-Loader.vue';
import ProfileLoader from '@/views/Loaders/Profile-Loader.vue';
import WalletLoader from '@/views/Loaders/Wallet-Loader.vue';
import SubAffiliatesLoader from '@/views/Loaders/SubAffiliates-Loader.vue';
import TrafficSourcesLoader from '@/views/Loaders/TrafficSources-Loader.vue';
import PostbacksLoader from '@/views/Loaders/Postbacks-Loader.vue';
import RequestLogLoader from '@/views/Loaders/RequestLog-Loader.vue';
import OffersLoader from '@/views/Loaders/Offers-Loader.vue';
import PromoCodesLoader from '@/views/Loaders/PromoCodes-Loader.vue';
import PromoMaterialsLoader from '@/views/Loaders/PromoMaterials-Loader.vue';
import SummaryLoader from '@/views/Loaders/Summary-Loader.vue';
import DailyLoader from '@/views/Loaders/Daily-Loader.vue';
import PlayersLoader from '@/views/Loaders/Players-Loader.vue';
import CustomLoader from '@/views/Loaders/Custom-Loader.vue';
import MediaBuyingLoader from '@/views/Loaders/MediaBuying-Loader.vue';
import CpaConversions from '@/views/Dashboard/Cpa/CpaConversions.vue';
import CohortReport from '@/views/Dashboard/CohortReport/CohortReport.vue';
import Kpi from '@/views/Dashboard/Kpi.vue';
import DomainsLoader from '@/views/Loaders/Domains-Loader.vue';

import authRequired from './hooks/auth_required';

export default {
  path: '/dashboard',
  component: DashboardLayout,
  beforeEnter: authRequired,
  children: [
    {
      path: 'main/:urlQuery?',
      name: 'routes.dashboard',
      component: withLoader({
        Component: Index,
        Loader: IndexLoader,
        Catch: IndexLoader,
      }),
    },
    {
      path: 'profile/:urlQuery?',
      name: 'routes.profile',
      component: withLoader({
        Component: Profile,
        Loader: ProfileLoader,
      }),
    },
    {
      path: 'contacts/:urlQuery?',
      name: 'routes.contacts',
      component: Contacts,
    },
    {
      path: 'payment-information/:urlQuery?',
      name: 'routes.paymentHistory',
      component: withLoader({
        Component: PaymentHistory,
        Loader: WalletLoader,
      }),
    },
    {
      path: 'kpi/:urlQuery?',
      name: 'routes.kpi',
      component: withLoader({
        Component: Kpi,
        Loader: WalletLoader,
      }),
    },
    {
      path: 'sub-affiliates/:urlQuery?',
      name: 'routes.subAffiliates',
      component: withLoader({
        Component: SubAffiliates,
        Loader: SubAffiliatesLoader,
      }),
    },
    {
      path: 'traffic-source/:urlQuery?',
      name: 'routes.trafficSource',
      component: withLoader({
        Component: TrafficSource,
        Loader: TrafficSourcesLoader,
      }),
    },
    {
      path: 'traffic-source/tag-manager/:id/:urlQuery?',
      name: 'routes.tagManager',
      component: withLoader({
        Component: TagManager,
        Loader: PostbacksLoader,
      }),
    },
    {
      // vue3-migration -- проблемы vue-router с распознованием путей (переопределяет traffic-source/:urlQuery?)
      path: 'traffic-source/postbacks/:id/:urlQuery?',
      name: 'routes.postbacks',
      component: withLoader({
        Component: Postbacks,
        Loader: PostbacksLoader,
      }),
    },
    {
      path: 'traffic-source/log/:id/request-log/:urlQuery?',
      name: 'routes.requestLog',
      component: withLoader({
        Component: RequestLog,
        Loader: RequestLogLoader,
      }),
    },
    {
      path: 'offers/:urlQuery?',
      name: 'routes.offers',
      component: withLoader({
        Component: Offers,
        Loader: OffersLoader,
      }),
    },
    {
      path: 'domains/:urlQuery?',
      name: 'routes.domains',
      component: withLoader({
        Component: Domains,
        Loader: DomainsLoader,
      }),
    },
    {
      path: 'promo-codes/:urlQuery?',
      name: 'routes.promoCodes',
      component: withLoader({
        Component: PromoCodes,
        Loader: PromoCodesLoader,
      }),
    },
    {
      path: 'android-apps/:urlQuery?',
      name: 'routes.androidApps',
      component: withLoader({
        Component: AndroidApps,
      }),
    },
    {
      path: 'promo-materials/:urlQuery?',
      name: 'routes.promoMaterials',
      component: withLoader({
        Component: PromoMaterials,
        Loader: PromoMaterialsLoader,
      }),
    },
    {
      path: 'media-buying-campaigns/:urlQuery?',
      name: 'routes.mediaBuying',
      component: withLoader({
        Component: AdvertisingCampaigns,
        Loader: MediaBuyingLoader,
      }),
    },
    {
      // vue3-migration -- проблемы vue-router с распознованием путей (переопределяет media-buying-campaigns/:urlQuery?)
      path: 'media-buying-campaigns-details/:id/:urlQuery?',
      name: 'routes.mediaBuyingCampaignDetails',
      component: withLoader({
        Component: DetailAdCampaign,
        Loader: MediaBuyingLoader,
      }),
    },
    {
      path: 'media-buying-campaigns-sub/:id/:urlQuery?',
      name: 'routes.mediaBuyingCampaignDetailsSub',
      component: withLoader({
        Component: DetailAdCampaignSub,
        Loader: MediaBuyingLoader,
      }),
    },
    {
      path: 'media-buying-payments/:urlQuery?',
      name: 'routes.mediaBuyingPayments',
      component: withLoader({
        Component: PaymentsView,
        Loader: MediaBuyingLoader,
      }),
    },
    {
      path: 'media-buying-posts/:urlQuery?',
      name: 'routes.mediaBuyingPosts',
      component: withLoader({
        Component: PostsView,
        Loader: MediaBuyingLoader,
      }),
    },
    {
      path: 'media-buying-links-checker/:urlQuery?',
      name: 'routes.mediaLinksChecker',
      component: withLoader({
        Component: LinksChecker,
      }),
    },

    {
      path: 'summary/:urlQuery?',
      name: 'routes.summary',
      component: withLoader({
        Component: Summary,
        Loader: SummaryLoader,
      }),
    },
    {
      path: 'daily/:urlQuery?',
      name: 'routes.daily',
      component: withLoader({
        Component: Daily,
        Loader: DailyLoader,
      }),
    },
    {
      path: 'players/:urlQuery?',
      name: 'routes.players',
      component: withLoader({
        Component: Players,
        Loader: PlayersLoader,
      }),
    },
    {
      path: 'custom/:urlQuery?',
      name: 'routes.custom',
      component: withLoader({
        Component: Custom,
        Loader: CustomLoader,
      }),
    },
    {
      path: 'sub-affiliate-reports/:urlQuery?',
      name: 'routes.subAffiliatesReports',
      component: withLoader({
        Component: SubAffiliatesReports,
        Loader: PlayersLoader,
      }),
    },
    {
      path: 'cpa-conversions/:urlQuery?',
      name: 'routes.cpaConversions',
      component: withLoader({
        Component: CpaConversions,
        Loader: PlayersLoader,
      }),
    },
    {
      path: 'cohort/:urlQuery?',
      name: 'routes.cohort',
      component: CohortReport,
    },
    {
      path: 'notifications',
      name: 'routes.notifications',
      component: withLoader({
        Component: Notifications,
      }),
    },
    {
      path: '*',
      name: 'routes.notfound',
      component: NotFound,
    },
  ],
};
